import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Card, Row, Col, Button, Form, Table, Modal } from 'react-bootstrap';
import Terminal from '../Terminal/Terminal';
import dateformat from '../../utilis/dateformat';

import { getToken } from '../../hooks/actions/sessionActions';

const wsUrl = process.env.REACT_APP_API_MONITORA.replace('https', 'wss').replace('http', 'ws');
const refreshRate = 15000

let socket;

const Conected = ({ user, serial }) => {

  const navigate = useNavigate();

  const requestRef = useRef(null);
  const prevImageUrlRef = useRef(null);

  const serialNumber = serial;

  if (user?.permission?.support?.read !== true) {
    window.location.replace('/home');
  }

  const [imageSrc, setImageSrc] = useState('');
  const [streamInternalCam, setStreamInternalCam] = useState(false);
  const [imageCamSrc, setImageCamSrc] = useState('');
  const [connectionStabished, setConnectionStabished] = useState(false)
  const [inputValueAlert, setInputValueAlert] = useState('');
  const [response, setResponse] = useState('Console\n');
  const [equipConfig, setEquipConfig] = useState({
    'serial': '--',
    'webcam': false,
    'freq_v': '--',
    'serv_e': '--',
    'serv_m': '--',
    'serv_d': '--',
    'calib_id': '--',
    'calib': '--',
    'eixo_x': '--',
    'eixo_y': '--',
    'eixo_z': '--',
    'v_firmware': '--',
    'v_firmware_osc': '--',
    'activation_date': '--',
    'activation_days': '--',
    'volume_corr_densidade': '--',
    'densidade_esfera': '--',
    'offset_bal1': '--',
    'offset_bal2': '--',
    'cross_check': '--',
    'sw': '--',
    'sws': '--'
  })

  // Estado para confirmação de ações críticas
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null); // 'calibrar' | 'chart'
  const openConfirm = (action) => { setConfirmAction(action); setShowConfirmModal(true); };
  const closeConfirm = () => { setShowConfirmModal(false); setConfirmAction(null); };

  // Atualiza o estado e reconecta quando serialNumber muda
  useEffect(() => {
    // Desconecta e limpa estados relevantes
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.close();
    }
    setImageSrc('');
    setStreamInternalCam(false);
    setImageCamSrc('');
    setConnectionStabished(false);
    setInputValueAlert('');
    setResponse('Console\n');
    setEquipConfig({
      'serial': '--',
      'webcam': false,
      'freq_v': '--',
      'serv_e': '--',
      'serv_m': '--',
      'serv_d': '--',
      'calib_id': '--',
      'calib': '--',
      'eixo_x': '--',
      'eixo_y': '--',
      'eixo_z': '--',
      'v_firmware': '--',
      'v_firmware_osc': '--',
      'activation_date': '--',
      'activation_days': '--',
      'volume_corr_densidade': '--',
      'densidade_esfera': '--',
      'offset_bal1': '--',
      'offset_bal2': '--',
      'cross_check': '--',
      'sw': '--',
      'sws': '--'
    });
    // Reconecta
    handleConnect();
    return () => {
      if (socket) socket.close();
      if (requestRef.current) {
        cancelAnimationFrame(requestRef.current);
      }
      if (prevImageUrlRef.current) {
        URL.revokeObjectURL(prevImageUrlRef.current);
      }
    };
  }, [serialNumber]);

  const handleSubmit = (inputValue) => {
    if (!connectionStabished) return;
    if (!socket || socket.readyState !== WebSocket.OPEN) return;

    const command = {
      type: 'message',
      room: serialNumber,
      content: {
        command: 'process',
        parameters: {
          command: inputValue
        }
      }
    };
    socket.send(JSON.stringify(command));
  };

  const handleSubmitAlert = (event) => {
    if (!inputValueAlert || !connectionStabished) return;
    if (!socket || socket.readyState !== WebSocket.OPEN) return;

    event.preventDefault();
    const command = {
      type: 'alert',
      room: serialNumber,
      msg: inputValueAlert
    };
    socket.send(JSON.stringify(command));

    setInputValueAlert('');
  };

  const base64ToBlob = (base64, mime = 'image/png') => {
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mime });
  };

  const handleNewFrame = (imgData) => {
    requestRef.current = requestAnimationFrame(() => {
      try {
        const blob = base64ToBlob(imgData, 'image/png');
        if (prevImageUrlRef.current) {
          URL.revokeObjectURL(prevImageUrlRef.current);
        }
        const objectUrl = URL.createObjectURL(blob);
        prevImageUrlRef.current = objectUrl;
        setImageSrc(objectUrl);
      } catch (err) {
        setImageSrc(`data:image/png;base64,${imgData}`);
      }
    });
  };

  const handleConnect = () => {
    let pingInterval
    // Criar uma nova instância WebSocket
    socket = new WebSocket(wsUrl);

    pingInterval = setInterval(() => {
      if (socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({ type: 'ping' }));
      }
    }, 20000);

    socket.onopen = () => {
      setConnectionStabished(true)
    };

    socket.onmessage = (event) => {
      const data = event.data;
      let json_msg = JSON.parse(data);

      if (json_msg.type === "invalid_user") {
        if (json_msg?.msg) {
          alert(json_msg?.msg)
        } else {
          alert("Sem permissão!");
        }
        handleDisconnect();
      }

      if (json_msg.type === "valid_user") {
        setConnectionStabished(true)
        handleLoadData()
      }

      if (json_msg.type === "desconnect") {
        setConnectionStabished(false)
      }

      if (json_msg.type === "connected") {
        console.log('connected');
        setConnectionStabished(true)
        handleLoadData()
      }

      if (json_msg.pubkey) {
        if (socket && socket.readyState === WebSocket.OPEN) {
          socket.send(
            JSON.stringify({
              type: 'join',
              room: serialNumber,
              user_id: user?._id,
              name: user?.name,
              email: user?.email,
              client: 'client',
              page: serialNumber.includes('SIMT') ? 'support' : serialNumber.includes('SEMT') ? 'supportdry' : '',
              token: getToken(),
              content: {
                name: `${user?.email}-SGU-ACESSO-REMOTO`
              },
            })
          );
        }
      } else {
        if (json_msg?.content?.img) {
          handleNewFrame(json_msg.content.img);
          return;
        }

        if (json_msg?.content?.text) {
          requestAnimationFrame(() => {
            setResponse(json_msg.content.text);
          });
          return;
        }

        if (json_msg?.content?.img_cam) {
          requestAnimationFrame(() => {
            setImageCamSrc(`data:image/png;base64,${json_msg.content.img_cam}`);
          });
          return;
        }

        if (json_msg?.content?.network_config) {
          // setNetworkConfig(json_msg.content.network_config);
          return;
        }

        if (json_msg?.content?.equip_config) {
          requestAnimationFrame(() => {
            setEquipConfig(json_msg.content.equip_config);
          });
          return;
        }
      }
    };

    socket.onclose = () => {
      clearInterval(pingInterval)
    };
  };

  const handleLoadData = () => {
    socket.send(
      JSON.stringify({
        type: 'message',
        room: serialNumber,
        content: {
          command: 'load_data',
          parameters: {}
        },
      })
    );

    socket.send(
      JSON.stringify({
        type: 'connect_support',
        room: serialNumber,
        hidden: user.master ? user.master : false
      })
    );
  }

  const handleImageClick = (event) => {
    if (!connectionStabished) return;
    if (!socket || socket.readyState !== WebSocket.OPEN) return;

    const rect = event.target.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    socket.send(
      JSON.stringify({
        type: 'message',
        room: serialNumber,
        content: {
          command: 'click',
          parameters: {
            x: x,
            y: y
          }
        }
      })
    );
  };

  const sendGetScreen = () => {
    if (!socket || socket.readyState !== WebSocket.OPEN) return;
    socket.send(
      JSON.stringify({
        type: 'connect_support',
        room: serialNumber,
        stream_internal_cam: streamInternalCam,
        hidden: user.master ? user.master : false
      })
    );
  };

  useEffect(() => {
    const interval1 = setInterval(() => {
      sendGetScreen();
    }, refreshRate);
    return () => {
      clearInterval(interval1);
    };
  }, [socket, streamInternalCam]);

  // Função para desconectar o WebSocket
  const handleDisconnect = () => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(
        JSON.stringify({
          type: 'desconnect_support',
          room: serialNumber
        })
      );
      socket.close();
      setConnectionStabished(false);
    }
    navigate('/home');
  };

  useEffect(() => {
    handleConnect();
    return () => {
      if (socket) socket.close();
      if (requestRef.current) {
        cancelAnimationFrame(requestRef.current);
      }
      if (prevImageUrlRef.current) {
        URL.revokeObjectURL(prevImageUrlRef.current);
      }
    };
  }, []);

  const handleChart = () => {
    if (!connectionStabished) return;
    if (!socket || socket.readyState !== WebSocket.OPEN) return;

    // É mais seguro e legível montar o comando Python separado.
    const pythonScriptCommand = `from db import getInstance as DB; db = DB(); db.clear_charts('CUSTOM'); db.clear_charts('COMPLEMENT')`;
    const fullShellCommand = `/home/orangepi/venv/bin/python -c "${pythonScriptCommand}"`;

    const command = {
      type: 'message',
      room: serialNumber,
      content: {
        command: 'process',
        parameters: {
          command: fullShellCommand
        }
      }
    };
    socket.send(JSON.stringify(command));
  }

  const handleCalibrar = () => {
    if (!connectionStabished) return;
    if (!socket || socket.readyState !== WebSocket.OPEN) return;

    // Função auxiliar para gerar SHA-256 (hex) usando Web Crypto API
    const sha256Hex = async (text) => {
      try {
        const encoder = new TextEncoder();
        const data = encoder.encode(text);
        const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
        return Array.from(new Uint8Array(hashBuffer))
          .map(b => b.toString(16).padStart(2, '0'))
          .join('');
      } catch (err) {
        console.error('Falha ao gerar SHA-256', err);
        return null;
      }
    };

    (async () => {
      const raw = `${serialNumber}Mtc`;
      const hash = await sha256Hex(raw);
      if (!hash) {
        alert('Não foi possível gerar hash para calibração.');
        return;
      }
      // Monta comando curl conforme solicitado
      const fullShellCommand = `curl -X GET http://localhost:3000/api/v1/atualizacalibracao/${hash}`;

      const command = {
        type: 'message',
        room: serialNumber,
        content: {
          command: 'process',
          parameters: {
            command: fullShellCommand
          }
        }
      };
      if (socket && socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify(command));
      }
    })();
  }

  return (
    <>
      <Card className='mb-2 p-2'>
        <Row className='g-2'>
          <Col>
            {connectionStabished ?
              <Alert variant="success" className='ms-1 me-1 mt-2 mb-2 p-2'>
                <p style={{ marginBottom: 0 }}>
                  Conectado
                </p>
              </Alert>
              :
              <Alert variant="danger" className='ms-1 me-1 mt-2 mb-2 p-2'>
                <p style={{ marginBottom: 0 }}>
                  Desconectado
                </p>
              </Alert>
            }
          </Col>
          <Col className='d-flex justify-content-end align-items-center'>
            {user?.master === true && (
              <Button
                variant="outline-warning"
                size="sm"
                className='ms-1 me-1 mt-1'
                onClick={() => { openConfirm('calibrar') }}
              >
                Calibrar
              </Button>
            )}
            <Button
              variant="outline-warning"
              size="sm"
              className='ms-1 me-1 mt-1'
              onClick={() => { openConfirm('chart') }}
            >
              Forçar atualizar curvas
            </Button>
            {/* <Button
              variant="outline-danger"
              size="sm"
              className='ms-1 me-1 mt-1'
              onClick={() => { handleDisconnect() }}
            >
              Desconectar
            </Button> */}
          </Col>
        </Row>
      </Card>

      <Card className='mb-2 p-2'>
        <Row className='g-2'>
          <Col>
            <div>
              {!imageSrc ? (
                <span style={{ color: 'black' }}>
                  Aguardando imagem...
                </span>
              ) : (
                <img
                  onClick={handleImageClick}
                  src={imageSrc}
                  style={{
                    width: '800px',
                    height: '480px',
                    objectFit: 'cover',
                    cursor: connectionStabished ? 'pointer' : 'none',
                    opacity: connectionStabished ? 1 : 0.7,
                    filter: connectionStabished ? 'none' : 'grayscale(100%)',
                    borderRadius: '5px', // Arredondar a borda da imagem
                    border: '3px solid grey', // Contorno sutil da imagem
                  }}
                />
              )}
            </div>
          </Col>

          <Col>
            <div className="p2" style={{ height: 480, maxWidth: 800, overflowY: 'auto' }}>
              <Terminal
                user={user}
                response={response}
                onCommandSubmit={handleSubmit}
                connectionStabished={connectionStabished}
              />
            </div>
          </Col>
        </Row>
      </Card>

      <Row className='g-2'>
        <Col md={6} className='d-flex flex-column'>
          <div className="p-2 bg-light border flex-grow-1 d-flex justify-content-center align-items-center">
            <Table style={{ fontSize: "0.9rem" }} striped bordered hover="true" responsive size='sm'>
              <tbody>
                <tr className="table-secondary">
                  <th className="text-center" scope="col">SERIAL</th>
                  <th className="text-center" scope="col">FREQUÊNCIA (V)</th>
                  <th className="text-center" scope="col">ID CALIBRAÇÃO</th>
                  <th className="text-center" scope="col">WEBCAM</th>
                </tr>
                <tr>
                  <td className="text-center">{equipConfig?.serial}</td>
                  <td className="text-center">{equipConfig?.freq_v}</td>
                  <td className="text-center">{equipConfig?.calib_id}</td>
                  <td className="text-center">{equipConfig?.webcam ? "Sim" : "Não"}</td>
                </tr>
                <tr className="table-secondary">
                  <th className="text-center" scope="col">DATA DE ATIVAÇÃO</th>
                  <th className="text-center" scope="col">DIAS DE ATIVAÇÃO</th>
                  <th className="text-center" scope="col">SOFTWARE</th>
                  <th className="text-center" scope="col">--</th>
                </tr>
                <tr>
                  <td className="text-center">{equipConfig?.activation_date ? dateformat(equipConfig?.activation_date, true) : ''}</td>
                  <td className="text-center">{equipConfig?.activation_days}</td>
                  <td className="text-center">{equipConfig?.sw}</td>
                  <td className="text-center">{"--"}</td>
                </tr>
              </tbody>
            </Table>
          </div>
        </Col>

        <Col md={3} className='d-flex flex-column'>
          <div className="p-2 bg-light border flex-grow-1">
            <Row className="d-flex flex-column align-items-center">
              <Col className="w-100 mb-2">
                <Form.Control
                  onChange={(e) => setInputValueAlert(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleSubmitAlert(e);
                    }
                  }}
                  type="text"
                  placeholder="Enviar alerta ao equipamento..."
                  value={inputValueAlert}
                  className="w-100"
                  disabled={!(user?.permission?.support?.write && connectionStabished)}
                />
              </Col>

              <Col className="w-100">
                <Button
                  variant="success"
                  onClick={handleSubmitAlert}
                  type="button"
                  className="w-100"
                  disabled={!(user?.permission?.support?.write && connectionStabished)}
                >
                  Enviar
                </Button>
              </Col>
            </Row>
          </div>
        </Col>

        <Col md={3} className='d-flex flex-column'>
          <div className="p-2 bg-light border flex-grow-1">
            <Row>
              <Col
                className='m-0'
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '220px'
                }}
              >
                {!streamInternalCam ? (
                  <Button
                    variant="success"
                    onClick={() => {
                      setStreamInternalCam(true);
                    }}
                    className="w-100"
                    disabled={connectionStabished && equipConfig.webcam ? false : true}
                  >
                    Abrir Câmera Interna do Equipamento
                  </Button>
                ) : imageCamSrc ? (
                  <img
                    alt="Screenshot"
                    src={imageCamSrc}
                    className="w-100"
                  />
                ) : (
                  <div
                    style={{
                      height: '100%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      textAlign: 'center',
                    }}
                  >
                    <h6 style={{ color: 'black' }}>Aguardando Imagem...</h6>
                  </div>
                )}
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      <Modal
        show={showConfirmModal}
        onHide={closeConfirm}
        centered
        backdrop="static"
        contentClassName={document.body.classList.contains('dark-theme') ? 'bg-dark text-light border-secondary' : 'bg-white'}
      >
        <Modal.Header
          closeButton
          className={document.body.classList.contains('dark-theme') ? 'bg-dark text-light border-secondary' : undefined}
          style={{ borderBottom: '1px solid', borderColor: document.body.classList.contains('dark-theme') ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.1)' }}
        >
          <Modal.Title className="fw-semibold" style={{ fontSize: '1rem' }}>Confirmação</Modal.Title>
        </Modal.Header>
        <Modal.Body
          className={document.body.classList.contains('dark-theme') ? 'bg-dark text-light' : undefined}
          style={{ background: document.body.classList.contains('dark-theme') ? '#1f2428' : '#fff' }}
        >
          {confirmAction === 'calibrar' && (
            <p className="mb-0">Tem certeza que deseja executar a calibração? Esta ação enviará um comando remoto ao equipamento.</p>
          )}
          {confirmAction === 'chart' && (
            <p className="mb-0">Confirmar atualização forçada das curvas? Isso pode limpar ou regenerar dados de gráfico.</p>
          )}
        </Modal.Body>
        <Modal.Footer
          className={document.body.classList.contains('dark-theme') ? 'bg-dark text-light border-secondary' : undefined}
          style={{ borderTop: '1px solid', borderColor: document.body.classList.contains('dark-theme') ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.1)' }}
        >
          <Button variant={document.body.classList.contains('dark-theme') ? 'outline-light' : 'secondary'} onClick={closeConfirm}>Cancelar</Button>
          <Button
            variant={document.body.classList.contains('dark-theme') ? 'outline-light' : 'primary'}
            onClick={() => {
              if (confirmAction === 'calibrar') {
                closeConfirm();
                handleCalibrar();
              } else if (confirmAction === 'chart') {
                closeConfirm();
                handleChart();
              } else {
                closeConfirm();
              }
            }}
          >
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Conected;
